// extracted by mini-css-extract-plugin
module.exports = {"flex":"prices_flex__WA3U_","container":"prices_container__osq8S","price":"prices_price__duDqs","priceTwo":"prices_priceTwo__Ux2lz","priceThree":"prices_priceThree__cXZkT"};